//#region IMPORT
import React, { useCallback, useEffect, useRef, useState } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { setSearchText } from '../../../../Reducer/SearchReducer';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import { mapParamsBySchema } from '../../../../util';
/** Components */
import { SER_BASIC } from './index';
import dayjs from 'dayjs';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useDelete from '../../../../hooks/useDeleteN';
import { useSave } from '../../../../hooks/useSaveN';
import { useDelete1, useSearch1 } from './SER_BASIC_QUERY';
import { SER_BASIC_Schema } from './SER_BASIC_Schema';
import { SER_BASIC_01_Schema } from '../SER_BASIC_01/SER_BASIC_01_Schema';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'SeriousAccidentAct';

const Title = [
  '1.경영자의 안전보건경영활동 (100점)',
  '2.위험성 평가 (100점)',
  '3.안전보건교육 (100점)',
  '4.근로자 참여 (100점)',
  '5.중대재해 대응조치 (100점)',
  '6.도급.용역.위탁 안전보건확보 (100점)',
  '7.평가 및 개선 (100점)',
  '8.안전문화 및 안전의식 (100점)',
  '9.가점 사항 (100점)',
];

function SER_BASICF() {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo, custInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const gridRef1 = useRef(); //그리드
  const onGridReady = (params) => {
    gridRef1.current = params;
  };
  const [indList, setIndList] = useState([]); //공통코드 데이터

  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: false, requireCust: true });

  /* 그리드 기능 변수 */
  const [rowData1, setRowData1] = useState([]); // 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);

  // 상태값 리셋
  const ResetLogic1 = useCallback(() => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  }, []);

  // QUERY: 삭제/조회 훅 연결
  const delete1 = useDelete1();
  const { refetch: Search1 } = useSearch1({
    onSuccess: (processedRows) => {
      setRowData1(processedRows);
    },
  });

  // 삭제 Handler
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  //#endregion

  const executed = useRef(false);

  useEffect(() => {
    if (executed.current) return;
    if (!searchInfo?.custCd) return;
    executed.current = true;
    // SearchLogic1을 deps로 잡지 않기 위해 효과 내에서 조회 로직을 직접 수행
    ResetLogic1();
    if (!validateSelection()) return;
    Search1();
  }, []);

  //조회버튼(value1 : 시작기간, value2 : 종료시간 , _value3: "사업장코드")
  const SearchLogic1 = useCallback(async () => {
    ResetLogic1();

    if (!validateSelection()) return;

    try {
      await Search1();
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
    }
  }, [ResetLogic1, validateSelection, Search1, dispatch]);

  //#endregion
  //#region 저장
  //저장버튼 클릭 시 함수(웹)
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    schema: SER_BASIC_Schema,
    getChangedRows: () => [], // 목록은 삭제만 지원
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: null,
    reset: () => {
      setChangedRowData1([]);
      setDeletedRowData1([]);
    },
    refresh: async () => {
      await SearchLogic1();
    },
  });

  const SaveLogic1 = async () => {
    const hasDelete = deletedRowData1.length > 0;
    if (!hasDelete) {
      dispatch(
        showSnackbar({ message: '삭제할 데이터가 없습니다.', type: 'warning' })
      );
      return;
    }
    await Save1();
  };

  //#endregion
  //#region 삭제

  //#endregion
  //#region 나머지 함수
  // 안전보건관리책임자 선임서 평가표 전체 인쇄 함수
  const PrintLogic1 = async (_item) => {
    let headerData = {};
    let tableData1 = [];

    try {
      if (!selectedRowData1 || selectedRowData1.length === 0) {
        dispatch(
          showSnackbar({
            message: '항목을 선택하세요.',
            type: 'warning',
          })
        );
        return;
      } else {
        const params1 = mapParamsBySchema(SER_BASIC_01_Schema.mapper.search1, {
          sdCode: _item.sdCode,
        });
        const res1 = await apiRequest(
          'post',
          Global.urls.SeriousAccidentAct.getSerBasic01R1,
          params1
        );
        const data = Array.isArray(res1?.data) ? res1.data : [];

        if (data.length === 0 || data?.[0]?.type === 'Error') {
          throw new Error(data?.[0]?.message || '인쇄할 데이터가 없습니다.');
        } else {
          const cust = custInfo.find((f) => f.custCd === searchInfo?.custCd);

          // 업종명(소분류)
          const industrialSmall = indList.find(
            (f) => f.indCd === cust.indCd
          )?.industrialSmall;

          // 평가등급 계산
          const workNo = cust?.workNo || 0; // WORK_NO 값
          const point = data[0]?.evaPoint || 0; // 총 점수
          let evaGrade = '초급'; // 기본값

          if (workNo >= 50 && workNo <= 300) {
            if (point < 400) {
              evaGrade = '초급'; //
            } else if (point >= 400 && point <= 559) {
              evaGrade = '중급';
            } else {
              evaGrade = '고급';
            }
          } else if (workNo >= 20 && workNo < 50) {
            if (point < 320) {
              evaGrade = '초급';
            } else if (point >= 320 && point <= 479) {
              evaGrade = '중급';
            } else {
              evaGrade = '고급';
            }
          } else if (workNo < 20) {
            if (point < 240) {
              evaGrade = '초급';
            } else if (point >= 240 && point <= 399) {
              evaGrade = '중급';
            } else {
              evaGrade = '고급';
            }
          }

          headerData = {
            ...data[0],
            evaDate: dayjs(_item.evaDate)
              .format('YYYY.MM.DD (dddd)')
              .replace('Monday', '월')
              .replace('Tuesday', '화')
              .replace('Wednesday', '수')
              .replace('Thursday', '목')
              .replace('Friday', '금')
              .replace('Saturday', '토')
              .replace('Sunday', '일'), // 평가일자
            ...cust,
            industrialSmall: industrialSmall, // 업종명
            workNo: workNo, // 상시근로자수
            evaGrade: evaGrade, // 평가등급
          };
        }

        const params2 = mapParamsBySchema(SER_BASIC_01_Schema.mapper.search2, {
          sdCode: _item.sdCode,
        });
        const res2 = await apiRequest(
          'post',
          Global.urls.SeriousAccidentAct.getSerBasic01R2,
          params2
        );
        const data2 = Array.isArray(res2?.data) ? res2.data : [];

        if (data2.length === 0 || data2?.[0]?.type === 'Error') {
          dispatch(
            showSnackbar({
              message: data2?.[0]?.message || '인쇄할 상세 데이터가 없습니다.',
              type: 'error',
            })
          );
          return;
        }

        // val1과 groupCd 기준으로 no 생성
        let currentVal1 = null;
        let currentGroupCd = null;
        let subNumber = 1;

        data2.forEach((item) => {
          item.title = Title[item.val1 - 1]; // 제목 매핑

          item.evaluation =
            item.checkYn === 'Y'
              ? '적정'
              : item.checkYn === 'N'
                ? '미흡'
                : item.checkYn === '0'
                  ? '해당없음'
                  : item.checkYn;

          if (item.checkYn === 'Y' || item.checkYn === '0') {
            const sameGroupCount = data2.filter(
              (d) => d.groupCd === item.groupCd
            ).length;
            item.score = item.val2 / sameGroupCount;
          } else {
            item.score = 0;
          }

          item.seriousDisasterNm =
            item.seriousDisaster.slice(-1) + '. ' + item.seriousDisasterNm;

          if (currentVal1 !== item.val1) {
            currentVal1 = item.val1;
            subNumber = 1;
          } else if (currentGroupCd !== item.groupCd) {
            subNumber++;
          }
          currentGroupCd = item.groupCd;
          item.no = `${item.val1}.${subNumber}`;
        });

        tableData1 = data2;
        const printData = {
          FileName: 'SER_BASIC',
          HeaderData: JSON.stringify(headerData),
          TableData1: JSON.stringify(tableData1),
        };
        await Commons.Axios(
          'report',
          Global.base.useUrl + Global.urls.Reports.reports,
          printData
        ).then((response) => {
          const blobUrl = URL.createObjectURL(response.data);
          window.open(blobUrl, '_blank'); // 새 탭에서 열기
        });
      }
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
    }
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  //#endregion

  return (
    <div className="wrap">
      <SER_BASIC
        userInfo={userInfo}
        //setUserInfo={setUserInfo}
        gridRef1={gridRef1}
        onGridReady={onGridReady}
        searchInfo={searchInfo}
        setSearchText={(t) => dispatch(setSearchText(t))}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        // 함수
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        SearchLogic1={SearchLogic1}
        SaveLogic1={SaveLogic1}
        PrintLogic1={PrintLogic1}
        handleRowSelection={handleRowSelection}
        deletedRowData1={deletedRowData1}
        setDeletedRowData1={setDeletedRowData1}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        NewYnErrorMsg={NewYnErrorMsg}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
      />
    </div>
  );
}

export default SER_BASICF;
